// Sandboxed iframe widget. URL is taken from props.src; sandbox is applied by
// default. Caller can override via props.sandbox (string) or props.allow.

import type { WidgetComponent } from "@viz/presentation";

const DEFAULT_SANDBOX = "allow-scripts allow-same-origin allow-popups allow-forms";

const IFrameWidget: WidgetComponent = ({ props }) => {
  const src = props.src as string | undefined;
  if (!src) {
    return <div className="grid h-full place-items-center text-sm text-slate-500">iframe: no src</div>;
  }
  const sandbox = (props.sandbox as string | undefined) ?? DEFAULT_SANDBOX;
  const allow = props.allow as string | undefined;
  const title = (props.title as string | undefined) ?? "embedded content";
  const height = (props.height as string | number | undefined) ?? "100%";
  return (
    <iframe
      src={src}
      title={title}
      sandbox={sandbox}
      allow={allow}
      style={{ width: "100%", height, border: 0, background: "#0f172a" }}
      referrerPolicy="no-referrer"
    />
  );
};

export default IFrameWidget;
